/**
 * Service API Endpoints
 * Centralized endpoint definitions for service operations.
 */
export const SERVICE_ENDPOINTS = {
  /**
   * Get internal database version
   * @method GET
   * @endpoint /service/dbversion
   */
  DB_VERSION: "/service/dbversion",

  /**
   * Get database server version
   * @method GET
   * @endpoint /service/database-server-ver
   */
  DB_SERVER_VERSION: "/service/database-server-ver",

  /**
   * Get application info (Core)
   * @method GET
   * @endpoint /service/info
   */
  INFO: "/service/info",

  /**
   * Get adapter application info
   * @method GET
   * @endpoint /service/adapter-info
   */
  ADAPTER_INFO: "/service/adapter-info",

  /**
   * Get application logo (SVG default)
   * @method GET
   * @endpoint /service/logo
   */
  LOGO: "/service/logo",

  /**
   * Get application logo in specific format
   * @method GET
   * @endpoint /service/logo/{format}
   * @param {LogoFormat} format - Logo format (svg or png)
   */
  LOGO_FORMAT: (format: string) => `/service/logo/${format}`,

  /**
   * Delete core cache
   * @method DELETE
   * @endpoint /service/cache
   */
  CACHE: "/service/cache",
} as const;
